import React from "react";
import PropTypes from 'prop-types';
import Image from '@lmig/dotcom-aspect-components/Utility/Image';

const OfficeLicensedIn = ({ licenses }) => {
  let columnnAmount = 3;

  if (licenses.length <= 5) {
    columnnAmount = 1;
  } else if (licenses.length <= 10) {
    columnnAmount = 2;
  }

  return (
    <div className="officeLicensedInWrapper">
      <div className="innerWrapper">
        <div className="licenseCard">
          <div className="officeLicensedInHeading">The agents in this office are licensed in...</div>
          <ul className="licenseList">
            {licenses.map(name => (<li key={name}>{name}</li>))}
          </ul>
        </div>
        <Image imageDomain="IMAGE" deferLoad>
          <img
            className="licenseInImage"
            src="/comparion/Woman_at_Desk.png?height=1000&width=1000"
            alt="Woman sitting at a desk on a sunny day."
            width="568"
            height="568"
          />
        </Image>
      </div>
      <style jsx>{`
        @import './global-styles/tokens';
        .officeLicensedInWrapper{
          margin-bottom: 2rem;
        }
        .innerWrapper{
          display: flex;
          align-items: flex-start;
          justify-content: space-around;
          margin-top: unset;

          @media screen and (min-width: $lm-breakpoint-md-min) {
            justify-content: space-between;
            margin-top: 7rem;
          }
        }
        .officeLicensedInHeading{
          font-weight: 700;
          font-size: 0.875rem;
          @media screen and (min-width: $lm-breakpoint-sm-min) {
            font-size: 1rem;
          }
          @media screen and (min-width: $lm-breakpoint-md-min) {
            font-size: 1.25rem
          }
        }
        .licenseList{
          columns: 2;
          column-gap: 2rem;
          padding-left: 1rem;
          li{
            margin-bottom: unset;
            font-size: 0.875rem;
            @media screen and (min-width: $lm-breakpoint-sm-min) {
              font-size: 1rem;
              margin-bottom: 0.5rem;
            }
          }
          @media screen and (min-width: $lm-breakpoint-lg-min) {
            columns: ${columnnAmount};
          }
        }
        .licenseInImage{
          max-width: 49%;
          display: none;
          @media screen and (min-width: $lm-breakpoint-md-min) {
            display: block;
          }
        }
        .licenseCard{
          background: #F5F5F5;
          border-radius: 3px;
          padding: 2rem;
          max-width: 568px;
          @media screen and (min-width: 900px) {
            padding: 2rem 4rem 2rem 4rem;
          }
        }
      `}</style>
    </div >
  );
};

OfficeLicensedIn.propTypes = {
  licenses: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default OfficeLicensedIn;
